const formatCurrency = (val, noFraction = false) => {
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: noFraction ? 0 : 2,
        maximumFractionDigits: noFraction ? 0 : 2
    }).format(val);
};

export default formatCurrency;